import { CommonModule } from '@angular/common';
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import {
  CarouselComponent,
  CarouselModule,
  OwlOptions,
} from 'ngx-owl-carousel-o';
import { ButtonModule } from 'primeng/button';
@Component({
  selector: 'app-plans-pricing',
  standalone: true,
  imports: [CommonModule, ButtonModule, CarouselModule],
  templateUrl: './plans-pricing.component.html',
  styleUrl: './plans-pricing.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class PlansPricingComponent {
  @ViewChild('owlCarousel', { static: false }) owlCarousel!: CarouselComponent;

  pricingPlans = [
    {
      id: 1,
      title: 'Residential 100',
      price: 99,
      frequency: 'month',
      description: 'Speeds up to 100 Mbps',
      features: [
        '$499 Basic Installation Fee',
        'Unlimited Data',
        'Full Fiber Optic to the Home (FTTH)',
        'No cancellation fee for 60 days',
        'Dynamic Public IP Address',
        'Residential Package',
      ],
      isHighlighted: false,
      buttonText: 'Order now',
    },
    {
      id: 2,
      title: 'Residential 500',
      price: 125,
      frequency: 'month',
      description: 'Speeds up to 500 Mbps',
      features: [
        '$499 Basic Installation Fee',
        'Unlimited Data',
        'Full Fiber Optic to the Home (FTTH)',
        'No cancellation fee for 60 days',
        'Dynamic Public IP Address',
        'Residential Package',
      ],
      isHighlighted: false,
      buttonText: 'Order now',
    },
    {
      id: 3,
      title: 'Residential Gig',
      price: 145,
      frequency: 'month',
      description: 'Speeds up to 1000 Mbps',
      features: [
        '$499 Basic Installation Fee',
        'Unlimited Data',
        'Full Fiber Optic to the Home (FTTH)',
        'No cancellation fee for 60 days',
        'Dynamic Public IP Address',
        'Residential Package',
      ],
      isHighlighted: true,
      buttonText: 'Order now',
    },
    {
      id: 4,
      title: 'Residential 2.5 Gig',
      price: 249,
      frequency: 'month',
      description: 'Speeds up to 2500 Mbps',
      features: [
        '$499 Basic Installation Fee',
        'Unlimited Data',
        'Full Fiber Optic to the Home (FTTH)',
        'No cancellation fee for 60 days',
        'Dynamic Public IP Address',
        'Residential Package',
      ],
      isHighlighted: false,
      buttonText: 'Order now',
    },
  ];

  customOptions: OwlOptions = {
    loop: true,
    nav: false,
    dots: false,
    autoplay: false,
    autoplayTimeout: 1000,
    margin: 20,
    responsive: {
      0: { items: 1 },
      485: { items: 1 },
      600: { items: 2 },
      800: { items: 2 },
      900: { items: 3 },
      1000: { items: 3 },
    },
  };
  constructor( private router:Router){}

  handleBookNow(planId: number) {
    console.log(`Booking for Plan ID: ${planId}`);
    this.router.navigate(['/orders'])

    // Add functionality for booking
  }
  goToNext() {
    this.owlCarousel.next();
  }

  // Custom previous button action
  goToPrev() {
    this.owlCarousel.prev();
  }
}
